import React from "react";
import { BsFileMinusFill } from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";
import "../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const DownButton = ({ id, onDocumentDeleted }) => {
  const handlerDown = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_LEALTAD_ABM_OF_DOCUMENT_DOWN}${id}`
      );
      if (response.status === 200 || response.status === 204) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "El documento ha sido dado de baja con exito",
        });
        onDocumentDeleted(id);
      }
    } catch (error) {
      // Maneja los errores de la solicitud
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al intentar dar de baja el documento.",
      });
    }
  };

  return (
    <button
      className="button_abm-lealtad"
      type="button"
      onClick={(e) => handlerDown(e)}
    >
      <i className="fa fa-refresh-lealtad"></i>
      <BsFileMinusFill className="icon-list-lealtad" />
    </button>
  );
};

export default DownButton;
